module.exports = __webpack_public_path__ + "img/IT0005111761411.2cd4988d.png";